import React from 'react';
import { LANGUAGE_EN, LANGUAGE_CN } from '@home/_config/config';

import ICON_SENSORTOWER from '@home/assets/svg/dataSource/sensortower.svg';

const sensortowerIcon = (
  <img
    style={{ position: 'relative', top: -1, verticalAlign: 'middle' }}
    width={16}
    height={16}
    src={ICON_SENSORTOWER}
  />
);

const textEnElements = {
  dbh_studio_casual_tips: (
    <span>
      The original data is sourced from {sensortowerIcon} SensorTower. IAP revenue does not deduct the 30% store
      commission.
    </span>
  ),
};

const textCnElements = {
  dbh_studio_casual_tips: <span>原始数据来源于 {sensortowerIcon} SensorTower，IAP收入指标未扣除30%商店佣金费用</span>,
};

const textElementsMap: IRecord<IRecord<string | React.ReactElement>> = {
  [LANGUAGE_EN as string]: textEnElements,
  [LANGUAGE_CN as string]: textCnElements,
};

export default function useElementLocale(locale: string) {
  const formatElementMessage = (params: { id: string }) => {
    const { id = '' } = params || {};

    const textElements = textElementsMap[locale] || textElementsMap[LANGUAGE_EN];

    return textElements?.[id] || '';
  };

  return { formatElementMessage };
}
